import React from 'react'

import PosMonitor from 'pages/admin/sql/PosMonitor'

/**
 * Монитор кассы в админке: любой бренд, любая точка, запись в базу кассы
 * разрешена. Сам экран общий с партнёрским разделом — см. PosMonitor.
 */
function Index() {
	return (
		<PosMonitor
			basePath='/admin'
			usersUrl='/admin/helper/users'
			posesUrl='/admin/sql/poses'
			allowWrite={true} />
	)
}

export default Index
